export default __webpack_public_path__ + "static/goa-logo-2021-73bb29433d3f127f80c9ae2febc1ddad.png";